export enum phoneNumbers {
  police = '110',
  fireAndRescueService = '112',
  roadSideAssistance = '089 20 20 4000',
}
